import React from 'react'
import { Link } from 'react-router-dom'
import config from '../Config'

const CoursesList = ({ data }) => {

    // console.log('first', data)

    function getSessionType(lesson_type) {
        switch (lesson_type) {
            case 'Manual': return (<div className="ribbon ribbon-top-left bg-light-green"><span>{lesson_type}</span></div>)
            case 'Automatic': return (<div className="ribbon ribbon-top-left bg-light-blue2"><span>{lesson_type}</span></div>)
        }
    }

    return (
        <div className='table-responsive'>
            <table className='jean-table table'>
                <tbody>
                    {
                        data?.map((course, i) => {
                            return (
                                <tr key={i}>
                                    <td className="box">
                                        <div className="therapist-info ">
                                            {getSessionType(course.cartype)}
                                        </div>
                                    </td>
                                    <td className=' '>
                                        <div>
                                            <img src={`${config.imageUrl}cources/${course.image}`} alt=""
                                                style={{width: '60px'}}
                                                className='cust-image border border-2 p-1' />
                                        </div>
                                    </td>

                                    <td>
                                        <div className='therapist-info'>
                                            <h4 className='mb-1 fs-5'>Course Title</h4>
                                            <p className='mb-0'>{course.title}</p>
                                        </div>
                                    </td>

                                    <td>
                                        <div className='therapist-info'>
                                            <h4 className='mb-1 fs-5'>Theory Session</h4>
                                            <p className='mb-0'>{course.theory === '0' || course.theory === "1" ? course.theory + " Hour" : course.theory + " Hours"}</p>
                                        </div>
                                    </td>

                                    <td>
                                        <div className='therapist-info'>
                                            <h4 className='mb-1 fs-5'>Practical Session</h4>
                                            <p className='mb-0'>{course.practical === '0' || course.practical === "1" ? course.practical + " Hour" : course.practical + " Hours"}</p>
                                        </div>
                                    </td>

                                    <td>
                                        <div className='action-buttons pe-2'>
                                            <Link to={`${config.appUrl}view-course-details/${course.id}`} className='bg-black'>
                                                <i className="icon-eye text-white"></i>
                                            </Link>
                                        </div>
                                    </td>

                                </tr>
                            )
                        })
                    }

                    {
                        data?.length === 0 &&
                        <div className="alert alert-success ps-4">No Course Found !!</div>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default CoursesList